export enum EGlobalPartnerFilterOptions {
  All = 'All',
  Synced = 'Synced',
  ITS = 'ITS',
}
